module.exports = __webpack_public_path__ + "img/mmi-home-graduate.77cf3296.png";